module.exports = __webpack_public_path__ + "static/media/vitality-logo.68d573e7.png";